export const hierarchy = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        delete_confrim_msg:"Are you sure you want to delete this hierarchy?",
        add:{
			success:'Hierarchy added successfully',
			error:'Unable to add hierarchy. Please try again',
        },
        hierarchy_management: "Hierarchy Definition",
        level:"Level"
    },
    ar: {
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف هذا التسلسل الهرمي؟",
        add:{
			success:'تمت إضافة التسلسل الهرمي بنجاح',
			error:'غير قادر على إضافة التسلسل الهرمي. حاول مرة اخرى',
        },
        hierarchy_management: "تعريف التسلسل الهرمي",
        level:"مستوى"
    }
}